//
// Copyright (c) 2011-2026 by Curalate, Inc.
//

import { TEMPLATE_GRID_CARD_WIDTH } from '@components/templates/templateConstants';
import GalleryContainerId from '@galleries/models/GalleryContainerId';
import ReelId from '@models/ReelId';

export enum GALLERIES_ACTIONS {
  OPEN_CREATE_GALLERY_MODAL = 'GALLERIES/OPEN_CREATE_GALLERY_MODAL',
  CLOSE_CREATE_GALLERY_MODAL = 'GALLERIES/CLOSE_CREATE_GALLERY_MODAL',

  SET_TYPE_OF_GALLERY = 'GALLERIES/SET_TYPE_OF_GALLERY',

  SET_GALLERY_LOCATION = 'GALLERIES/SET_GALLERY_LOCATION',

  SET_AUTO_APPROVAL_STRATEGY = 'GALLERIES/SET_AUTO_APPROVAL_STRATEGY',
  SET_AUTO_APPROVAL_ENABLED = 'GALLERIES/SET_AUTO_APPROVAL_ENABLED',

  SET_NEW_GALLERY_NAME = 'GALLERIES/SET_NEW_GALLERY_NAME',
  SET_NEW_GALLERY_NAME_ERROR = 'GALLERIES/SET_NEW_GALLERY_NAME_ERROR',

  REQUEST_CREATE_GALLERY = 'GALLERIES/REQUEST_CREATE_GALLERY',
  RECEIVE_CREATE_GALLERY_SUCCEEDED = 'GALLERIES/RECEIVE_CREATE_GALLERY_SUCCEEDED',
  RECEIVE_CREATE_GALLERY_FAILED = 'GALLERIES/RECEIVE_CREATE_GALLERY_FAILED',
  CLEAR_CREATE_GALLERY_ERROR = 'GALLERIES/CLEAR_CREATE_GALLERY_ERROR',

  OPEN_CUSTOMIZE_GALLERY_MODAL = 'GALLERIES/OPEN_CUSTOMIZE_MODAL',
  CLOSE_CUSTOMIZE_GALLERY_MODAL = 'GALLERIES/CLOSE_CUSTOMIZE_MODAL',

  OPEN_EMBED_GALLERY_MODAL = 'GALLERIES/OPEN_EMBED_MODAL',
  CLOSE_EMBED_GALLERY_MODAL = 'GALLERIES/CLOSE_EMBED_MODAL',

  SHOW_LOCALIZATION_SAVE_WARNING = 'GALLERIES/SHOW_LOCALIZATION_SAVE_WARNING',
  CLEAR_LOCALIZATION_SAVE_WARNING = 'GALLERIES/CLEAR_LOCALIZATION_SAVE_WARNING',

  SHOW_CUSTOMISATIONPANEL_ERROR_STATUS = 'GALLERIES/SHOW_CUSTOMISATIONPANEL_ERROR_STATUS',
  HIDE_CUSTOMISATIONPANEL_ERROR_STATUS = 'GALLERIES/HIDE_CUSTOMISATIONPANEL_ERROR_STATUS',

  OPEN_DELETE_GALLERY_MODAL = 'GALLERIES/OPEN_DELETE_GALLERY_MODAL',
  CLOSE_DELETE_GALLERY_MODAL = 'GALLERIES/CLOSE_DELETE_GALLERY_MODAL',
  SET_DELETE_GALLERY_NAME = 'GALLERIES/SET_DELETE_GALLERY_NAME_INPUT',
  REQUEST_DELETE_GALLERY = 'GALLERIES/REQUEST_DELETE_GALLERY',
  RECEIVE_DELETE_GALLERY_SUCCEEDED = 'GALLERIES/RECEIVE_DELETE_GALLERY_SUCCEEDED',
  RECEIVE_DELETE_GALLERY_FAILED = 'GALLERIES/RECEIVE_DELETE_GALLERY_FAILED',
  CLEAR_DELETE_GALLERY_ERROR = 'GALLERIES/CLEAR_DELETE_GALLERY_ERROR',

  REQUEST_UPDATE_GALLERY_NAME = 'GALLERIES/REQUEST_UPDATE_GALLERY_NAME',
  RECEIVE_UPDATE_GALLERY_NAME_SUCCEEDED = 'GALLERIES/RECEIVE_UPDATE_GALLERY_NAME_SUCCEEDED',
  RECEIVE_UPDATE_GALLERY_NAME_FAILED = 'GALLERIES/RECEIVE_UPDATE_GALLERY_NAME_FAILED',
  CLEAR_UPDATE_GALLERY_NAME_ERROR = 'GALLERIES/CLEAR_UPDATE_GALLERY_NAME_ERROR',

  OPEN_ADD_TO_GALLERIES_MODAL = 'GALLERIES/OPEN_ADD_TO_GALLERIES_MODAL',
  CLOSE_ADD_TO_GALLERIES_MODAL = 'GALLERIES/CLOSE_ADD_TO_GALLERIES_MODAL',
  ADD_MODAL_SELECT_GALLERY = 'GALLERIES/ADD_MODAL_SELECT_GALLERY',
  ADD_MODAL_DESELECT_GALLERY = 'GALLERIES/ADD_MODAL_DESELECT_GALLERY',
  ADD_MODAL_SET_SELECTED_GALLERIES = 'GALLERIES/ADD_MODAL_SET_SELECTED_GALLERIES',
  TOGGLE_BAZAAR_VOICE_SYNDICATION = 'GALLERIES/TOGGLE_BAZAAR_VOICE_SYNDICATION',

  SELECT_GALLERY = 'GALLERIES/SELECT_GALLERY',

  UPDATE_SEARCH_VALUE = 'GALLERIES/UPDATE_SEARCH_VALUE',
  UPDATE_SOURCES_VALUE = 'GALLERIES/UPDATE_SOURCES_VALUE',
  UPDATE_DATE_RANGE_VALUE = 'GALLERIES/UPDATE_DATE_RANGE_VALUE',

  RECEIVE_MATERIALIZED_ITEMS = 'GALLERIES/RECEIVE_MATERIALIZED_ITEMS',
  CLEAR_MATERIALIZED_ITEMS = 'GALLERIES/CLEAR_MATERIALIZED_ITEMS',
  SELECT_IMAGE = 'GALLERIES/SELECT_IMAGE',
  DESELECT_IMAGE = 'GALLERIES/DESELECT_IMAGE',
  CLEAR_IMAGES = 'GALLERIES/CLEAR_IMAGES',
  IS_LOADING = 'GALLERIES/IS_LOADING',
  RECEIVE_RIGHTS_REQUEST_STATES = 'GALLERIES/RECEIVE_RIGHTS_REQUEST_STATES',
}

export enum MEDIA_AUTOFILL_MODAL_ACTIONS {
  SET_READY_TO_SHOW_MEDIA_AUTOFILL_MODAL = 'MEDIA_AUTOFILL_MODAL/SET_READY_TO_SHOW_MEDIA_AUTOFILL_MODAL',
  OPEN_MEDIA_AUTOFILL_MODAL = 'MEDIA_AUTOFILL_MODAL/OPEN_MEDIA_AUTOFILL_MODAL',
  CLOSE_MEDIA_AUTOFILL_MODAL = 'MEDIA_AUTOFILL_MODAL/CLOSE_MEDIA_AUTOFILL_MODAL',
  SET_MODAL_CONTENT = 'MEDIA_AUTOFILL_MODAL/SET_MODAL_CONTENT',
}

export enum UNMODERATED_CONTENT_MODAL_ACTIONS {
  OPEN_UNMODERATED_CONTENT_MODAL = 'UNMODERATED_CONTENT_MODAL_ACTIONS/OPEN_UNMODERATED_CONTENT_MODAL',
  CLOSE_UNMODERATED_CONTENT_MODAL = 'UNMODERATED_CONTENT_MODAL_ACTIONS/CLOSE_UNMODERATED_CONTENT_MODAL',
}

export enum REQUEST_RIGHTS_MODAL_ACTIONS {
  OPEN_MODAL = 'REQUEST_RIGHTS_MODAL/OPEN_MODAL',
  CLOSE_MODAL = 'REQUEST_RIGHTS_MODAL/CLOSE_MODAL',
  SELECT_IMAGE = 'REQUEST_RIGHTS_MODAL/SELECT_IMAGE',
  DESELECT_IMAGE = 'REQUEST_RIGHTS_MODAL/DESELECT_IMAGE',
  HAS_CHROME_EXTENSION = 'REQUEST_RIGHTS_MODAL/HAS_CHROME_EXTENSION',
  RESET_MODAL = 'REQUEST_RIGHTS_MODAL/RESET_MODAL',
  IS_PENDING_APPROVAL = 'REQUEST_RIGHTS_MODAL/IS_PENDING_APPROVAL',
}

export enum REQUEST_RIGHTS_MODAL_NON_MENTIONED_ACTIONS {
  OPEN_MODAL = 'REQUEST_RIGHTS_MODAL_NON_MENTIONED/OPEN_MODAL',
  CLOSE_MODAL = 'REQUEST_RIGHTS_MODAL_NON_MENTIONED/CLOSE_MODAL',
  SET_SELECTED_INDEX = 'REQUEST_RIGHTS_MODAL_NON_MENTIONED/SET_SELECTED_INDEX',
  REQUEST_RIGHTS = 'REQUEST_RIGHTS_MODAL_NON_MENTIONED/REQUEST_RIGHTS',
  REQUEST_RIGHTS_SUCCEEDED = 'REQUEST_RIGHTS_MODAL_NON_MENTIONED/REQUEST_RIGHTS_SUCCEEDED',
  REQUEST_RIGHTS_FAILED = 'REQUEST_RIGHTS_MODAL_NON_MENTIONED/REQUEST_RIGHTS_FAILED',
  SKIP_APPROVAL = 'REQUEST_RIGHTS_MODAL_NON_MENTIONED/SKIP_APPROVAL',
  SKIP_APPROVAL_SUCCEEDED = 'REQUEST_RIGHTS_MODAL_NON_MENTIONED/SKIP_APPROVAL_SUCCEEDED',
  SKIP_APPROVAL_FAILED = 'REQUEST_RIGHTS_MODAL_NON_MENTIONED/SKIP_APPROVAL_FAILED',
}

export enum RIGHTS_OWNED_OR_PENDING_MODAL_ACTIONS {
  OPEN_MODAL = 'RIGHTS_OWNED_OR_PENDING_MODAL/OPEN_MODAL',
  CLOSE_MODAL = 'RIGHTS_OWNED_OR_PENDING_MODAL/CLOSE_MODAL',
}

export enum RIGHTS_SKIPPED_MODAL_ACTIONS {
  OPEN_MODAL = 'RIGHTS_SKIPPED_MODAL/OPEN_MODAL',
  CLOSE_MODAL = 'RIGHTS_SKIPPED_MODAL/CLOSE_MODAL',
}

export const GALLERIES_GRID_IMAGE_WIDTH = TEMPLATE_GRID_CARD_WIDTH;
export const GALLERIES_GRID_IMAGE_HEIGHT = TEMPLATE_GRID_CARD_WIDTH;
export const GRID_CONTENT_CARD_BOTTOM_HEIGHT = 82;
export const GALLERIES_GRID_CARD_WIDTH = GALLERIES_GRID_IMAGE_WIDTH;
export const GALLERIES_GRID_CARD_HEIGHT =
  GALLERIES_GRID_IMAGE_HEIGHT + GRID_CONTENT_CARD_BOTTOM_HEIGHT;

export const BULK_RIGHTS_WORKFLOW_LARGE_MEDIA_WIDTH = 700;
export const BULK_RIGHTS_WORKFLOW_SMALL_MEDIA_WIDTH = 400;

export const GALLERY_CONTAINER_ID_QUERY_PARAM = 'containerId';

export enum NO_GALLERIES_MODAL_ACTIONS {
  OPEN_MODAL = 'NO_GALLERIES_MODAL/OPEN_MODAL',
  CLOSE_MODAL = 'NO_GALLERIES_MODAL/CLOSE_MODAL',
}

export enum PREVIEW_GALLERY_MODAL_ACTIONS {
  OPEN_MODAL = 'PREVIEW_GALLERY_MODAL/OPEN_MODAL',
  CLOSE_MODAL = 'PREVIEW_GALLERY_MODAL/CLOSE_MODAL',
  SET_PREVIEW_OPTIONS = 'PREVIEW_GALLERY_MODAL/SET_PREVIEW_OPTIONS',
  REQUEST_DISMISSED_ALERTS = 'PREVIEW_GALLERY_MODAL/REQUEST_DISMISSED_ALERTS',
  REQUEST_DISMISSED_ALERTS_SUCCEEDED = 'PREVIEW_GALLERY_MODAL/REQUEST_DISMISSED_ALERTS_SUCCEEDED',
  REQUEST_DISMISSED_ALERTS_FAILED = 'PREVIEW_GALLERY_MODAL/REQUEST_DISMISSED_ALERTS_FAILED',
  DISMISS_ALERT = 'PREVIEW_GALLERY_MODAL/DISMISS_ALERT',
  DISMISS_ALERT_FAILED = 'PREVIEW_GALLERY_MODAL/DISMISS_ALERT_FAILED',
  DISMISS_ALERT_SUCCEEDED = 'PREVIEW_GALLERY_MODAL/DISMISS_ALERT_SUCCEEDED',
  SET_ALERT_FIRST_AND_LATEST_VIEW = 'PREVIEW_GALLERY_MODAL/SET_ALERT_FIRST_AND_LATEST_VIEW',
  SET_ALERT_LATEST_VIEW = 'PREVIEW_GALLERY_MODAL/SET_ALERT_LATEST_VIEW',
}

export enum PINNED_MEDIA_TOOLBAR_ACTIONS {
  OPEN_TOOLBAR = 'PINNED_MEDIA_TOOLBAR/OPEN_TOOLBAR',
  CLOSE_TOOLBAR = 'PINNED_MEDIA_TOOLBAR/CLOSE_TOOLBAR',
}

export enum GALLERIES_TOAST_TYPES {
  PINNED_MEDIA = 'GALLERIES_TOAST_TYPES/PINNED_MEDIA',
}

export const InstaShopDisabledMessage = `You can only add media from your own Instagram to your InstaShop.
                                              You will not be able to add any user-generated content.`;

export const PDP_AND_CATEGORY_AUTOFILL_TEXT = `We're automatically adding all media already in your Galleries here
                                                to maximize product coverage of category and product pages.`;

export const INSTASHOP_DISCONNECTED_INSTAGRAM_TEXT =
  'You must connect an Instagram account to create an InstaShop. ';

export const getAutofillText = (isInstashop: boolean) => {
  return `We're automatically publishing media to your ${
    isInstashop ? 'InstaShop' : 'Gallery'
  }
    to maximize the amount of content in your experience. Don't worry, we'll have your
    relevant brand content published within a few minutes.`;
};

const createNewGalleryPrefix = 'create-new-gallery';
const embedGalleryModalPrefix = 'embed-gallery-modal';
const gallerySettingsPrefix = 'gallery-settings-modal_';
const galleryPageHeaderPrefix = 'gallery-page-header';
const pinnedMediaThumbnailPrefix = 'pinned-media-thumbnail';
const pinnedButtonPrefix = 'pinned-media';
const galleriesContentCardsPrefix = 'galleries-content-card';
const galleriesManagement = 'galleries-management';
const galleryContentGrid = 'gallery-content-grid';
const galleryList = 'gallery-list';
const bulkRightsPrefix = 'bulk-rights';
const configureRightsModalPrefix = 'rights-configuration';
const unmoderatedContentModalPrefix = 'unmoderated-content-modal_';

export const GalleriesTrackingIds = {
  EMBED_GEO_DISCOVERY_COPY_URL_BUTTON: `${embedGalleryModalPrefix}-copy-url-button`,

  ESSENTIALS_CREATE_INSTASHOP_CTA_TRACKING_ID:
    'instashop-content-empty-state_create-new-instashop-cta',

  ALL_BRAND_CONTENT_TRACKING_ID: `${gallerySettingsPrefix}all-brand-content`,
  ONLY_PRODUCTIZED_CONTENT_TRACKING_ID: `${gallerySettingsPrefix}productized-content`,

  PIN_BUTTON_CLASSNAME_AND_TRACKING_ID: `${pinnedButtonPrefix}-pin`,
  UNPIN_BUTTON_CLASSNAME_AND_TRACKING_ID: `${pinnedButtonPrefix}-unpin`,

  PINNED_MEDIA_THUMBNAIL_GALLERY_PREVIEW: `${pinnedMediaThumbnailPrefix}-preview`,
  PINNED_MEDIA_THUMBNAIL_GALLERIES_DASHBOARD: `${pinnedMediaThumbnailPrefix}-dashboard`,
  PINNED_MEDIA_THUMBNAIL_PREVIEW_TOOLBAR: `${pinnedMediaThumbnailPrefix}-preview-toolbar`,

  GALLERY_CONTENT_CARDS_REQUEST_RIGHTS_CTA: `${galleriesContentCardsPrefix}-request-rights-cta`,
  GALLERY_CONTENT_CARDS_TAG_PRODUCTS_CTA: `${galleriesContentCardsPrefix}-tag-products-cta`,

  GALLERY_MANAGEMENT_CUSTOMIZE_BUTTON_TRACKING_ID: `${galleriesManagement}-customize-button`,
  GALLERY_MANAGEMENT_EMBED_BUTTON_TRACKING_ID: `${galleriesManagement}-embed-button`,
  GALLERY_MANAGEMENT_RIGHTS_CONFIGURATION_BUTTON: `${galleriesManagement}-rights-configuration-button`,
  GALLERY_MANAGEMENT_GALLERY_SETTINGS_DROPDOWN: `${galleriesManagement}-settings-dropdown`,
  GALLERY_MANAGEMENT_GALLERY_AUTO_PUBLISH_SYNDICATION_BUTTON: `${galleriesManagement}-auto-publish-syndication-button`,
  GALLERY_MANAGEMENT_GALLERY_AUTO_PUBLISH_GALLERY_BUTTON: `${galleriesManagement}-auto-publish-gallery-button`,
  GALLERY_MANAGEMENT_ENABLE_AUTO_PUBLISHING_SYNDICATION: `${galleriesManagement}-enable-auto-publishing-syndication-checkbox`,
  GALLERY_MANAGEMENT_ENABLE_AUTO_PUBLISHING_GALLERY: `${galleriesManagement}-enable-auto-publishing-gallery-checkbox`,

  GALLERY_FIND_MEDIA_BUTTON_TRACKING_ID: 'galleries-find-media-button',
  GALLERY_LIST_TRACKING_ID: galleryList,
  GALLERY_LIST_HEADER_TRACKING_ID: `${galleryList}-header`,
  GALLERY_DISTRIBUTION_HEADER_TRACKING_ID: 'gallery-distribution-header',

  GALLERY_DISTRIBUTE_TRACKING_ID: 'galleries-distribute-checkbox',
  GALLERY_BVNETWORK_DISTRIBUTE_TRACKING_ID: 'bvnetwork-distribute-checkbox',
  GALLERY_CHECKBOX_PREFIX: 'galleries-checkbox-',
  GALLERY_CHECKBOX_ITEM: 'galleries-checkbox-item',

  REQUEST_RIGHTS_NON_MENTIONED_MODAL_TITLE:
    'request-rights-non-mentioned-modal-title',

  UNMODERATED_CONTENT_MODAL_CLOSED: `${unmoderatedContentModalPrefix}closed`,
  UNMODERATED_CONTENT_MODAL_AUTO_APPROVE: `${unmoderatedContentModalPrefix}auto-approve`,
  UNMODERATED_CONTENT_MODAL_REMIND_ME_LATER: `${unmoderatedContentModalPrefix}remind-me-later`,
  UNMODERATED_CONTENT_MODAL_VIEW_ITEMS: `${unmoderatedContentModalPrefix}view-items`,

  GALLERY_PAGE_HEADER_NAME: `${galleryPageHeaderPrefix}-name`,
  GALLERY_PAGE_HEADER_DATA_SOURCE_ID_COPY: `${galleryPageHeaderPrefix}-data-source-id-copy`,

  NEW_GALLERY_BUTTON_TRACKING_ID: `${createNewGalleryPrefix}-button`,

  REQUEST_RIGHTS_AT_MENTIONED: `${bulkRightsPrefix}-request-rights-at-mentioned-modal`,
  ADD_TO_GALLERIES_WORKFLOWS_LOADER: `${bulkRightsPrefix}-add-to-galleries-workflows-loader`,

  GALLERY_CONTENT_GRID_ITEM: (cuid: string) =>
    `${galleryContentGrid}-item-${cuid}`,
  GALLERY_CONTENT_GRID_ITEM_BULK_ADD: (cuid: string) =>
    `${galleryContentGrid}-bulk-add-${cuid}`,
  GALLERY_CONTENT_GRID_ITEM_PIN: `${galleryContentGrid}-pin`,
  GALLERY_CONTENT_GRID_ITEM_UNPIN: `${galleryContentGrid}-unpin`,
  GALLERY_CONTENT_GRID_ITEM_REQUEST_RIGHTS: `${galleryContentGrid}-request-rights-cta`,
  GALLERY_CONTENT_GRID_ITEM_TAG_PRODUCTS: `${galleryContentGrid}-tag-products-cta`,

  GALLERY_IMAGE_GRID_CONTAINER: `${galleryContentGrid}-container`,
  GALLERY_IMAGE_GRID_LOADING_BAR: `${galleryContentGrid}-loading-bar`,

  RIGHTS_CONFIGURATION_MODAL: `${configureRightsModalPrefix}-modal`,
  RIGHTS_CONFIGURATION_MODAL_REQUIRE_RIGHTS_APPROVAL: `${configureRightsModalPrefix}-require-rights-approval`,
  RIGHTS_CONFIGURATION_MODAL_DONT_REQUIRE_RIGHTS: `${configureRightsModalPrefix}-dont-require-rights-approval`,
  RIGHTS_CONFIGURATION_MODAL_SAVE: `${configureRightsModalPrefix}-save`,
  RIGHTS_CONFIGURATION_MODAL_CANCEL: `${configureRightsModalPrefix}-cancel`,
  RIGHTS_CONFIGURATION_MODAL_CLOSE: `${configureRightsModalPrefix}-close`,
  RIGHTS_CONFIGURATION_MODAL_PUBLISH_WITHOUT_RIGHTS: `${configureRightsModalPrefix}-publish-without-rights`,
  RIGHTS_CONFIGURATION_MODAL_UNPUBLISH: `${configureRightsModalPrefix}-unpublish`,
} as const;

export const BulkAddtoGalleriesWorkflowTitles = {
  ADD_TO_GALLERIES: 'add to galleries',
  REQUEST_RIGHTS: 'request rights',
};

export enum GALLERY_CREATION_STEPS {
  TYPE = 'galleryType',
  LOCATION = 'galleryLocation',
  AUTO_APPROVAL = 'autoApproval',
  NAME = 'name',
}

export const FAKE_BAZAARVOICE_NETWORK_CONTAINER_ID =
  GalleryContainerId('bazaarvoiceNetwork');

export const FAKE_BAZAARVOICE_NETWORK_REEL_ID = ReelId('bazaarvoice_network');
